import styled from 'styled-components';
import Colors from 'assets/Colors';

const IconWrapper = styled.div`
  background: ${Colors.BG_MENU};
  border-radius: 5px;
  display: grid;
  height: 42px;
  width: 42px;
  place-items: center;
  margin-right: 14px;
  min-width: 42px;
`;

const InformationWrapper = styled.div`
  display: flex;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const TopText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
`;

const BottomText = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: ${Colors.text_secondary};
`;
export default {
  IconWrapper,
  InformationWrapper,
  TextWrapper,
  TopText,
  BottomText,
};
